export function initPasswordReset() {
  const form = document.getElementById("password-reset-form");
  if (!form) return;

  const formWrapper = form.closest(".password-reset__wrapper");
  const formMessage = form.querySelector(".form-message");
  const emailInput = form.querySelector('input[name="email"]');
  const submitButton = form.querySelector('button[type="submit"]');
  const originalButtonText = submitButton.textContent;

  const showMessage = (message, type) => {
    if (!formMessage) return;
    formMessage.textContent = message;
    formMessage.classList.remove("success", "error");
    formMessage.classList.add(type);
    formMessage.style.display = "block";
  };

  const hideMessage = () => {
    if (!formMessage) return;
    formMessage.style.display = "none";
    formMessage.classList.remove("success", "error");
    formMessage.textContent = "";
  };

  const showSuccessState = (message) => {
    if (!formWrapper) return;
    const successMessage = document.createElement("div");
    successMessage.className = "password-reset__success-message";
    successMessage.innerHTML = `
      <h2 class="password-reset__title">${passwordResetVars.messages.checkEmail}</h2>
      <p class="password-reset__subtitle">${message}</p>
      <a href="${passwordResetVars.loginUrl}" class="link-text">${passwordResetVars.messages.backToLogin}</a>
    `;
    formWrapper.innerHTML = "";
    formWrapper.appendChild(successMessage);
  };

  const validateEmail = (email) => {
    if (!email) {
      showMessage(passwordResetVars.messages.emptyEmail, "error");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showMessage(passwordResetVars.messages.invalidEmail, "error");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    hideMessage();

    const email = emailInput?.value.trim();
    if (!validateEmail(email)) return;

    try {
      submitButton.textContent = passwordResetVars.messages.sending;
      submitButton.disabled = true;
      emailInput.disabled = true;

      const formData = new FormData();
      formData.append("action", "handle_password_reset");
      formData.append("nonce", passwordResetVars.nonce);
      formData.append("email", email);

      const response = await fetch(passwordResetVars.ajaxUrl, {
        method: "POST",
        body: formData,
        credentials: "same-origin",
      });

      const data = await response.json();

      if (data.success) {
        showSuccessState(data.data.message);
      } else {
        showMessage(data.data.message, "error");
        submitButton.textContent = originalButtonText;
        submitButton.disabled = false;
        emailInput.disabled = false;
      }
    } catch (error) {
      showMessage(passwordResetVars.messages.error, "error");
      submitButton.textContent = originalButtonText;
      submitButton.disabled = false;
      emailInput.disabled = false;
    }
  };

  form.addEventListener("submit", handleSubmit);
  emailInput?.addEventListener("input", hideMessage);
}

document.addEventListener("DOMContentLoaded", initPasswordReset);
